import { styled } from 'styled-components'

export const StyledPaywallFaqContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
